<template>
  <SaveCanvas :name="`${card.code}-${card.title}`" @actions="toggleActions">
    <v-card light class="mapping">
      <v-card-title class="mb-0 pb-0">{{ card.title }} </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <div class="block letter">
          <v-chip color="red">{{ card.code }}</v-chip>
        </div>
        <v-row>
          <v-col cols="6">
            <p class="text-caption my-1 py-0">Category</p>
            <v-chip small class="blue lighten-3 mr-1">{{
              card.categories
              }}</v-chip>
          </v-col>
          <v-col cols="6">
            <p class="text-caption my-1 py-0">Type</p>
            <v-chip small class="yellow lighten-1">{{
              card.zones
              }}</v-chip>
          </v-col>
        </v-row>

        <p class="text-caption my-1 py-0">Description</p>
        <p class="my-0 text-body">
          {{ card.description }}
        </p>
        <p v-if="card.subitems.length" class="text-caption my-2 py-0">
          Messages
        </p>
        <div class="d-flex flex-column mapping__card__steps">
          <div class="mapping__card__step" v-for="(chip, index) in card.subitems"
            :key="`${card.id}-sub${chip.title}-${index}`">
            {{ chip }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="actions">
        <v-btn small outlined @click="editNote(card)">Edit</v-btn>
        <v-btn small outlined @click="showNote(card)">Show</v-btn>
        <v-btn small outlined @click="deleteNote(card)">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </SaveCanvas>
</template>

<script>
import { SaveCanvas } from "@/components/core";
// @ is an alias to /src

export default {
  name: "UserMappingCard",
  components: { SaveCanvas },
  data() {
    return {
      open: false,
      actions: true,
    };
  },
  props: {
    card: Object,
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedOpen() {
      return this.isOpen || this.open ? true : false;
    },
    exapndable() {
      if (this.subitems || this.description) {
        return this.subitems || this.description ? true : false;
      } else {
        return this.description ? true : false;
      }
    },
    label() {
      return this.open ? "Close" : "Expand";
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    toggleActions(val) {
      this.actions = val;
    },
    editNote(id) {
      console.log("edit note", id);
      this.$emit("editNote", id);
    },
    showNote(id) {
      console.log("show note", id);
      this.$emit("showNote", id);
    },
    deleteNote(id) {
      console.log("delete note", id);
      this.$emit("deleteNote", id);
    },
    getColor(cat) {
      switch (cat) {
        case "Brand":
          return "amber";
        case "Restrictions":
          return "red";
        case "Orientation":
          return "blue";
        case "Interpretation":
          return "green";
        case "Other":
          return "orange";
        default:
          return "grey";
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.block {
  display: block;
}
</style>
